import { EUiTagTag, type TUiTagOption } from '@experience/core-tag-ui';
import type { LocationQueryRaw } from 'vue-router';
import type { ExtendedPartTagType } from '@/entities/rubrics';
import { buildRubricTagRoute } from '@/entities/rubrics/lib/buildRubricTagRoute';
import { moreValue } from '@/widgets/rubricsBlock/lib/consts';

export const mapRubricsToTagOptions = (
  tags: ExtendedPartTagType[],
  selectedSlug: string,
  filterQuery: LocationQueryRaw,
): TUiTagOption[] => {
  return tags.map((tag) => {
    const isMoreTag = tag.value === moreValue;
    const route = isMoreTag ? null : buildRubricTagRoute(tag.url, filterQuery);

    return {
      label: tag.label,
      counter: tag.counter,
      to: route,
      as: isMoreTag || !route ? EUiTagTag.SPAN : EUiTagTag.ROUTER_LINK,
      isSelected: tag.value === selectedSlug,
      ...(tag.id !== undefined ? { id: String(tag.id) } : {}),
    };
  });
};
